import i18n from "@/i18n";
import {
    AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
    AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

// One confirmation before a drag-fill replaces already planned days.
export function ScheduleFillConfirm({ pending, onCancel, onConfirm }) {
    const plan = pending?.plan;
    const n = plan?.occupied || 0;
    const time = plan ? `${plan.shift.start_time}–${plan.shift.end_time}` : "";
    return (
        <AlertDialog open={Boolean(pending)} onOpenChange={(v) => { if (!v) onCancel(); }}>
            <AlertDialogContent data-testid="workforce-fill-confirm-dialog">
                <AlertDialogHeader>
                    <AlertDialogTitle data-testid="workforce-fill-confirm-title">
                        {i18n.t("wf.scheduleFillConfirm.replacePlannedDays", "Replace planned days?")}
                    </AlertDialogTitle>
                    <AlertDialogDescription data-testid="workforce-fill-confirm-body">
                        {i18n.t("wf.scheduleFillConfirm.body", { count: n, time, defaultValue_one: "{{count}} of the selected days already has a shift. It will be replaced with {{time}}. Days with a day code are left unchanged. Draft only — publish when ready.", defaultValue_other: "{{count}} of the selected days already have shifts. They will be replaced with {{time}}. Days with a day code are left unchanged. Draft only — publish when ready." })}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <Button variant="outline" onClick={onCancel} data-testid="workforce-fill-confirm-cancel">
                        {i18n.t("common.cancel", "Cancel")}
                    </Button>
                    <Button onClick={onConfirm} data-testid="workforce-fill-confirm-replace">
                        {i18n.t("wf.scheduleFillConfirm.replace", "Replace")}
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
